'use strict';

const Link = require('system/domain/entity/link');
const Backbone = require('backbone');

module.exports = Backbone.Collection.extend({
    model: Link,

    getLinksHasEdgeOf: function(uid, uid2) {
        if(!uid2) {
            return this.filter(function(link) {
                return link.source.id == uid || link.target.id == uid;
            })
        } else {
            return this.filter(function(link) {
                return (link.source.id == uid && link.target.id == uid2) || (link.source.id == uid2 && link.target.id == uid);
            })
        }
    }
});



// WEBPACK FOOTER //
// ./system/domain/collection/link.js